export default __webpack_public_path__ + "static/altlayer-65e666c1bd157b800ecad7f7774ab3ef.png";